import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/SearchOutlined';
import { searchFieldSx, colors } from '../../theme/tokens';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
}

export default function SearchField({
  value,
  onChange,
  placeholder = 'Search...',
  fullWidth = false,
}: SearchFieldProps) {
  return (
    <Box data-readonly-interactive="true" sx={fullWidth ? { width: '100%' } : undefined}>
      <TextField
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth={fullWidth}
        sx={searchFieldSx}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 18, color: colors.textTertiary }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
